/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_Key_Moth_PauseInputs */

const fr_actual_key_moth_pause = /** @type {(inputs: Actual_Key_Moth_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une semaine`)
};

/**

* @param {Actual_Key_Moth_PauseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const actual_key_moth_pause = /** @type {((inputs?: Actual_Key_Moth_PauseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_Key_Moth_PauseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_actual_key_moth_pause(inputs)
});